import { LmsInfoTypes } from '../../../constants/types';
import { CourseId } from '../../../constants/types/lms/type';
import { AssignmentCategory } from '../../../constants/types/student/homework/type';

export type CourseName =
  | 'KIDS'
  | 'BASIC'
  | 'ADVANCED'
  | 'HFHJ'
  | 'WMW'
  | 'OTHERS';

export type CourseGroup = '영어교실' | '주일학교';

export type CourseType = 'HOME' | 'CHURCH' | 'NONE';

interface CourseConfig {
  name: CourseName;
  group: CourseGroup;
  courseType: CourseType;
  assignmentCategory: AssignmentCategory;
}

export const COURSE_CONFIG: Partial<Record<CourseId, CourseConfig>> = {
  [CourseId.KIDS]: {
    name: 'KIDS',
    group: '영어교실',
    courseType: 'NONE',
    assignmentCategory: 'NONE',
  },

  [CourseId.BASIC]: {
    name: 'BASIC',
    group: '영어교실',
    courseType: 'HOME',
    assignmentCategory: 'JEBSON',
  },

  [CourseId.ADVANCED]: {
    name: 'ADVANCED',
    group: '영어교실',
    courseType: 'NONE',
    assignmentCategory: 'NONE',
  },

  [CourseId.HFHJ]: {
    name: 'HFHJ',
    group: '주일학교',
    courseType: 'CHURCH',
    assignmentCategory: 'HFHJ',
  },

  [CourseId.WMW]: {
    name: 'WMW',
    group: '주일학교',
    courseType: 'CHURCH',
    assignmentCategory: 'WMW',
  },
};

export const getCourseConfig = (courseId?: string) => {
  if (!courseId) return undefined;

  return COURSE_CONFIG[courseId as CourseId];
};

export const getCourseType = (
  classId: string,
  lmsLists: LmsInfoTypes,
): CourseType => {
  if (classId !== lmsLists?.id) {
    return 'NONE';
  }

  return getCourseConfig(lmsLists.course?.id)?.courseType ?? 'NONE';
};
